import React from "react";
import "./contactinfostyles.css";
import contactImage from "../assets/contactus.jpg"; // Ensure this image is in your assets folder

function ContactInfo() {
  return (
    <div className="contact-info-container">
      <div className="contact-info-text">
        <h2 className="contact-title">Get in Touch</h2>
        <p className="contact-detail">📞 +92 3009402541</p>
        <p className="contact-detail">📞 +92-3330037768</p>
        <p className="contact-detail">✉️ arcityofficial@gmail.com</p>
        <p className="contact-detail">🏢 Office Address: 1234 Street, City, Pakistan</p>
        <p className="contact-detail">🕒 Working Hours: Mon-Fri, 9:00 AM - 6:00 PM</p>
        <p className="contact-detail">🌐 Website: arcity.vercel.app</p>
      </div>
      <div className="contact-image">
        <img src={contactImage} alt="Contact Us" />
      </div>
    </div>
  );
}

export default ContactInfo;
